import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import Checkbox from '../Checkbox/index.js';
import Columnizer from '../Columnizer/index.js';
import CheckboxWithVisual from '../CheckboxWithVisual/index.js';

/**
 *  CheckboxGroup generates a group of checkbox elements that will fire a supplied callback when interacted with.
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
const CheckboxGroup = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    options = [],
    buttons,
    columnClasses,
    columns,
    hasVisual,
    withCheckmark = false,
    labelClassName,
    type = 'stacked',
    onChange = () => {},
    value = [],
    ...rest
  } = _ref;
  const isStacked = type === 'stacked';
  const checkboxes = options.map(option => {
    const checked = value.includes(option.value);
    const labelClasses = clsx(labelClassName, {
      'btn btn-default checkbox-btn': buttons,
      'checkbox-inline': !isStacked && !columnClasses,
      active: buttons && checked
    });
    delete option.isFiltersCollapsed;
    delete option.moreInfo;
    delete option.filterBadge;
    return hasVisual ? /*#__PURE__*/_jsx(CheckboxWithVisual, {
      ref: ref,
      checked: checked,
      onChange: onChange,
      multiple: true,
      src: option.src,
      colorValue: option.colorValue,
      withCheckmark: withCheckmark,
      labelClassName: labelClasses,
      ...option,
      ...rest
    }, option.value) : /*#__PURE__*/_jsx(Checkbox, {
      ref: ref,
      checked: checked,
      onChange: onChange,
      multiple: true,
      labelClassName: labelClasses,
      ...option
    }, option.value);
  });
  const columnize = items => /*#__PURE__*/_jsx(Columnizer, {
    items: items,
    columns: columns,
    columnClasses: columnClasses
  });
  return /*#__PURE__*/_jsx("div", {
    "data-cmp": "checkboxGroup",
    className: clsx({
      'checkbox-group': true,
      row: hasVisual
    }),
    ...rest,
    children: columns ? columnize(checkboxes) : checkboxes
  });
});
export default CheckboxGroup;